import app from '~/app';
import linkedProducts from './product/linked-products';
import mobileImages from './product/mobile-images';
import product from './product/main';
import productAnimations from './product/product-animations';
import productBottomDescription from './product/product-bottom-description';
import productForm from './product/product-form';
import productImages from './product/product-images';
import productTextAnimation from '../components/product-text-animation';
import productTopDescription from './product/product-top-description';
import recommendations from './product/recommendations';

app.add({
  linkedProducts,
  mobileImages,
  product,
  productAnimations,
  productBottomDescription,
  productForm,
  productImages,
  productTextAnimation,
  productTopDescription,
  'product-recommendations': recommendations,
});
app.mount();
